import { apiClient } from './api';

interface RegisterFcmTokenPayload {
  token: string;
  platform?: 'web' | 'android' | 'ios';
  userAgent?: string;
}

export const realtimeNotificationsService = {
  registerFcmToken: async (payload: RegisterFcmTokenPayload): Promise<void> => {
    await apiClient.post('/realtime-notifications/tokens/register', payload);
  },

  unregisterFcmToken: async (token: string): Promise<void> => {
    await apiClient.post('/realtime-notifications/tokens/unregister', { token });
  },
};

